const isTestCricket = (cricketType) => {
  return ['test', 'firstClass'].indexOf(cricketType) !== -1
}
export default isTestCricket
